import React, {useState} from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

const MainLayout = () => {

  const [collapsed, setCollapsed] = useState(false);
  const isSpinnerActive = useSelector(
    (state) => state.spinnerReducer.spinnerActive
  );
  const profileData = useSelector((s) => s.userReducer.profileData);

  return (
    <div id="layout-wrapper">
      {/* Spinner Overlay */}
      {isSpinnerActive && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
            flexDirection: "column",
            color: "#fff",
            fontFamily: "sans-serif",
          }}
        >
          <div className="spinner-glow">
            <Spinner
              animation="border"
              variant="light"
              role="status"
              style={{ width: "4rem", height: "4rem" }}
            >
              {/* <span className="visually-hidden">Loading...</span> */}
            </Spinner>
          </div>
          {/* <p style={{ marginTop: "15px", fontSize: "1.2rem" }}>Loading...</p> */}
        </div>
      )}

      {/* Layout */}
      <Header />
      <Sidebar setCollapsed = {setCollapsed} collapsed = {collapsed}/>
      <div className="vertical-overlay" />

      <div className={`main-content ${collapsed ? "collapsed" : ""}`}>
        <div className="page-content ps-3 pe-3 ps-lg-2 pe-lg-2">
          {profileData?.licenseExpiryMessage && (
            <p className="text-danger fs-5 ps-4 text-center mb-4">
              {profileData?.licenseExpiryMessage}
            </p>
          )}
          <Outlet />
        </div>
        <Footer />
      </div>

      {/* Extra CSS for glowing animation */}
      <style jsx="true">{`
        .spinner-glow {
          display: inline-block;
          animation: pulse 1.5s infinite;
        }
        @keyframes pulse {
          0% {
            transform: scale(1);
            filter: drop-shadow(0 0 5px #0d6efd);
          }
          50% {
            transform: scale(1.2);
            filter: drop-shadow(0 0 20px #0d6efd);
          }
          100% {
            transform: scale(1);
            filter: drop-shadow(0 0 5px #0d6efd);
          }
        }
      `}</style>
    </div>
  );
};

export default MainLayout;
